import React, {useState, useEffect, useCallback, useMemo} from "react"
import ComponentWrapper from "components/HOC/ComponentWrapper"
import {get, post} from "helpers/api"
import styled from "styled-components"
import {Button} from "@uprise/button"
import {text} from "@uprise/typography"
import {Card} from "@uprise/card"
import {spacing} from "@uprise/spacing"
import {Modal} from "@uprise/modal"
import {H4, H5, H6} from "@uprise/headings"
import DropDown from "components/shared/DropDown"
import RoleTable from "./RoleTable"
import {useHistory} from "react-router-dom"

const HeaderWrapper = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
`
const HeaderLeftSection = styled.div`
	display: flex;
	flex: 0.8;
	flex-direction: row;
	align-items: center;
`

const HeaderRightSection = styled.div`
	display: flex;
	flex: 0.2;
	justify-content: center;
	align-items: center;
`
const ActionButtonContainer = styled.div`
	display: flex;
	gap: 10px;
	justify-content: center;
	align-items: center;
`
const DeleteButton = styled(Button)`
	width: 100%;
	max-width: 60px;
	height: 32px;
	font-family: "Proxima Nova";
	font-size: ${text.t4};
	font-weight: normal;
	font-stretch: normal;
	font-style: normal;
	line-height: 1.38;
	letter-spacing: normal;
	text-align: center;
	color: #f6f4fc;
	background-color: #d9534f;
	border-color: #d9534f;
`
const RoleDetails = props => {
	console.log(props)
    const history = useHistory()
	const [users, setUsers] = useState([])
	const {
		match: {
			params: {id}
		},
		location: {
			state: {roleName}
		}
	} = props
	const getUsersByRole = async () => {
		try {
			const response = await get(`roles/user/${id}`)
			console.log(response)
			if (response.code === "success") {
				setUsers(response.message)
			}
		} catch (error) {
			console.log(error)
		}
	}

	useEffect(() => {
		getUsersByRole()
	}, [])

	const ActionComponent = ({id, row}) => {
		return (
			<ActionButtonContainer>
				<DeleteButton
					title={"Remove"}
					variant={"primary"}
					// onClick={() => setDeleteModalOpen(true)}
					data-testid='deleteButton'
				/>
			</ActionButtonContainer>
		)
	}

	const columns = useMemo(
		() => [
			// { Header: "id", accessor: "id", show: false },
			{
				Header: "User name",
				accessor: "name",
				disableSortBy: true,
				show: true
			},
			{
				Header: "User email",
				accessor: "email",
				disableSortBy: true,
				show: true
			},
			{
				Header: "Action",
				disableSortBy: true,
				// accessor: "",
				Cell: cellInfo => <ActionComponent id={cellInfo.row.original.id} row={cellInfo.row.original} />,
				show: true
			}
		],
		[]
	)

	const renderHeaderSection = () => {
		return (
			<HeaderWrapper>
				<HeaderLeftSection>
					<label>Role name:</label>
					<H4 style={{marginLeft: 20}}>{roleName || ""}</H4>
				</HeaderLeftSection>
				<HeaderRightSection>
					<Button
						title={"Edit"}
						size='medium'
						variant={"primary"}
						fullWidth={false}
						style={{
							alignSelf: "flex-end",
							width: 100,
							display: "flex"
						}}
						onClick={() => {
							history.push({
								pathname: "/roles/edit",
								state: {
									roleId: id
								}
							})
						}}
					/>
				</HeaderRightSection>
			</HeaderWrapper>
		)
	}
	return (
		<ComponentWrapper menuActiveIndex={17} subMenuActiveIndex={17} headerTitle='Role Details'>
			<Card padding={spacing.s10} backgroundColor='white' style={{display: "flex", flexDirection: "column"}}>
				{renderHeaderSection()}
			</Card>
			<Card padding={spacing.s10} backgroundColor='white'>
				<RoleTable data={users} columns={columns} />
			</Card>
		</ComponentWrapper>
	)
}

export default RoleDetails
